import { DistanceUnit } from "../enums/configuration/units";

const getLimitedValue = (inputValue: number, min: number, max: number) => {
  return Math.min(max, Math.max(min, inputValue));
};

const convertValueToCorrectMetric = (value: number | null | undefined, distanceUnit: DistanceUnit, multiplier: number) => {
  if (value == null) return value;
    if (distanceUnit === DistanceUnit.IMPERIAL) {
        return Math.round(value * multiplier * 10) / 10;
    }
    return value;
};


export {
    getLimitedValue,
    convertValueToCorrectMetric,
}